export default "__VITE_ASSET__CI7FG1_0__"